module.exports = __webpack_public_path__ + "img/back_active3.e5e1cc4f.png";